import React, { useState } from "react";
import "./spellcheck.css";
import { ArrowLeft } from "@mui/icons-material";

const wordSets = [
  { words: ["recieve", "believe", "friend", "separate"], correct: "receive" },
  {
    words: ["definately", "necessary", "beginning", "beautiful"],
    correct: "definitely",
  },
  {
    words: ["accommodate", "occurred", "tommorow", "embarrass"],
    correct: "tomorrow",
  },
  {
    words: ["maintain", "privilege", "calender", "February"],
    correct: "calendar",
  },
  {
    words: ["conscience", "supercede", "existence", "judgment"],
    correct: "supersede",
  },
];

const SpellCheckGame = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedWord, setSelectedWord] = useState(null);
  const [userInput, setUserInput] = useState("");
  const [score, setScore] = useState(0);
  const [message, setMessage] = useState("");

  const currentSet = wordSets[currentIndex];

  const handleWordClick = (word) => {
    setSelectedWord(word);
    setUserInput(""); // Reset input when a new word is selected
    setMessage(""); // Clear message on new selection
  };

  const checkAnswer = () => {
    if (!selectedWord) {
      setMessage("Select a word first!");
      return;
    }

    const incorrectWord = currentSet.words.find(
      (word) => word !== currentSet.correct
    );

    if (
      selectedWord === incorrectWord &&
      userInput.toLowerCase() === currentSet.correct.toLowerCase()
    ) {
      setMessage("Correct!");
      setScore(score + 1);
      setTimeout(() => {
        if (currentIndex < wordSets.length - 1) {
          setCurrentIndex(currentIndex + 1);
          setSelectedWord(null);
          setUserInput("");
          setMessage("");
        } else {
          setMessage(`Game Over! You scored ${score + 1}/${wordSets.length}`);
        }
      }, 1000);
    } else {
      setMessage("Try again!");
    }
  };

  return (
    <div className="full-background">
      <button
        style={{
          position: "absolute",
          top: "16px",
          left: "16px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "6px 12px",
          backgroundColor: "#e5e7eb",
          color: "#374151",
          borderRadius: "12px",
          border: "none",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
        }}
      >
        <a
          href="/games"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <ArrowLeft size={20} />
          <span style={{ fontSize: "16px", fontWeight: "500" }}>Back</span>
        </a>
      </button>
      <div className="game-container">
        <h2>Spell Check Game</h2>
        <p style={{ fontFamily: "sans-serif", color: "black" }}>
          Find the misspelled word and type its correct spelling.
        </p>

        {currentIndex < wordSets.length ? (
          <>
            <div>
              {currentSet.words.map((word, index) => (
                <button
                  key={index}
                  onClick={() => handleWordClick(word)}
                  className={selectedWord === word ? "selected" : ""}
                >
                  {word}
                </button>
              ))}
            </div>

            {selectedWord && (
              <>
                <input
                  type="text"
                  placeholder="Type correct spelling"
                  value={userInput}
                  onChange={(e) => setUserInput(e.target.value)}
                />
                <br />
                <button type="button" onClick={checkAnswer}>
                  Submit
                </button>
              </>
            )}

            <p className="message">{message}</p>
          </>
        ) : (
          <h3>{message}</h3>
        )}

        <p className="score">
          Score: {score}/{wordSets.length}
        </p>
      </div>
    </div>
  );
};

export default SpellCheckGame;
